<template>
  <div class="logo-card">
    <div class="img-wrapper" :class="logoInfo.theme">
      <img class="logo" :src="logoInfo.previewImage.url" alt="logo" />
    </div>
    <div class="info-wrapper">
      <h4 class="name">{{ logoInfo.name }}</h4>
      <p class="info" v-if="logoInfo.filename">
        {{ logoInfo.filename }} | size:
        <span v-if="logoInfo.size && logoInfo.size.width"
          >{{ logoInfo.size.width }} x {{ logoInfo.size.height }}
        </span>
        <span v-if="logoInfo.size && logoInfo.size.volume"
          >{{ logoInfo.size.volume }} Mb
        </span>
      </p>
      <p class="tips" v-html="logoInfo.remark"></p>
      <div class="download" v-if="isWxwork">
        {{
          logoInfo.type === 'ppt'
            ? '请使用PC端浏览器下载'
            : '请长按左侧图片保存'
        }}
      </div>
      <div class="download" v-else>
        下载：
        <a
          href="#"
          v-if="logoInfo.type == 'image'"
          @click="downloadFile(logoInfo)"
          >{{ logoInfo.format ? logoInfo.format.toUpperCase() : '文件' }}</a
        >
        <a v-else :href="logoInfo.fileInfo.url" target="_blank" download="">{{
          logoInfo.format ? logoInfo.format.toUpperCase() : '文件'
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    logoInfo: {
      type: Object,
      required: true,
    },
    picWidth: {
      type: String,
      default: '80%',
    },
  },
  data() {
    return {
      // 垃圾企业微信不支持下载 让用户长按保存
      isWxwork: window.navigator.userAgent.includes('wxwork'),
    };
  },
  methods: {
    downloadFile(logoInfo) {
      const { fileInfo, filename } = logoInfo;
      const name = fileInfo.key.slice(fileInfo.key.indexOf(filename));
      this.requestFile(fileInfo.url, name);
    },
    requestFile(url, fileName, type) {
      axios(url, { responseType: 'blob' }).then((res) => {
        let blob = new Blob([res.data], { type: '' });
        this.downloadByBlob(blob, fileName);
      });
    },
    downloadByBlob(blob, fileName) {
      let url = window.URL.createObjectURL(blob);
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style lang="scss" scoped>
.logo-card {
  display: flex;
  flex: 0 0 49%;
  width: 49%;
  margin-bottom: 10px;
  padding: 18px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  transition: 0.3s;

  .logo {
    max-width: 95%;
    max-height: 95%;
  }

  &:hover {
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
  }

  .img-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 186px;
    width: 186px;
    height: 124px;
    margin-right: 24px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.06);

    &.light {
      background: #fff;
    }

    &.dark {
      background: rgba(0, 0, 0, 0.5);
    }
  }

  .info-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;

    .name {
      flex: 0 0 auto;
      margin-bottom: 8px;
      font-size: 16px;
      color: #222;
    }

    .info,
    .tips {
      flex: 0 0 auto;
      word-break: break-all;
      font-size: 12px;
      color: #999;
    }
  }

  .download {
    position: absolute;
    bottom: 0;
    right: 0;
    flex: 0 0 auto;
    justify-content: flex-end;
    align-self: flex-end;
    font-size: 12px;
    color: #999999;

    a {
      color: #ff961e;
      margin-right: 10px;

      &:nth-last-of-type(1) {
        margin-right: 0;
      }
    }
  }
}
</style>
